module.exports = __webpack_public_path__ + "static/laura_06-7c9d3c6c27679101d7637127474dbd79.jpg";